module.exports = __webpack_public_path__ + "static/media/pedestrian.85d5f871.svg";